import React from "react";
import Blocks from "editorjs-blocks-react-renderer";
import ImageRenderer from "../imageRenderer";

const RichTextCols = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <section className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto my-10 lg:my-12 xl:p-0 p-5 ">
      <h2 className="text-5xl font-bold">{data.TitleH2}</h2>
      <h3 className="text-2xl font-normal">{data.SubTitleH3}</h3>
      <div className="grid md:grid-cols-2 gap-8 mt-0">
        {data.RichTextLeftCol?.data?.RichTextLeftCol ? (
          <div
            className={`prose prose-p:font-normal prose-p:text-lg ${
              data.TextAlignmentLeft ? "text-left" : "text-center"
            }`}
          >
            <Blocks
              data={JSON.parse(data.RichTextLeftCol?.data?.RichTextLeftCol)}
              renderers={{
                image: ImageRenderer,
              }}
            />
          </div>
        ) : (
          ""
        )}
        {data.RichTextRightCol?.data?.RichTextRightCol ? (
          <div
            className={`prose prose-p:font-normal prose-p:text-lg ${
              data.TextAlignmentLeft ? "text-left" : "text-center"
            }`}
          >
            <Blocks
              data={
                data.RichTextRightCol?.data?.RichTextRightCol &&
                JSON.parse(data.RichTextRightCol?.data?.RichTextRightCol)
              }
              renderers={{
                image: ImageRenderer,
              }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </section>
  );
};

export default RichTextCols;
